import rootReducer from "./rootReducer";
import { applyMiddleware, createStore, compose } from "redux";
import thunk from "redux-thunk";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const cmsStore = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

export default cmsStore;
